/* eslint-disable react-hooks/exhaustive-deps */
// src/pages/ListingCabs.js
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";
import LoginPopup from "./popup/LoginPopup";
import SEO from "../components/common/SEO";
import './CabsListing.css';
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import CabCard from "./CabCard";
import axios from "axios";
import ListingFilterBar from "../components/common/ListingFilterBar";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const libraries = ["places"];

/* -------------------------
   KEEP YOUR SearchForm (same as you provided)
   ------------------------- */
function SearchForm({ initial = {}, onSearch }) {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAP_KEY,
    libraries,
  });

  const fromAutoRef = useRef(null);
  const toAutoRef = useRef(null);

  const [fromLabel, setFromLabel] = useState(initial.from || "");
  const [toLabel, setToLabel] = useState(initial.to || "");

  const [fromPlace, setFromPlace] = useState(null);
  const [toPlace, setToPlace] = useState(null);

  const normalizeAreaName = (value = "") => {
    const text = String(value || "").trim();
    if (!text) return "";
    const cleaned = text.replace(/\b(?:East|West|North|South|Northeast|Northwest|Southeast|Southwest)\b$/i, "").trim();
    return cleaned || text;
  };

  const placeToLabel = (place) => {
    if (!place) return "";

    const comp = place.address_components || [];
    const findType = (type) => {
      const c = comp.find((x) => x.types && x.types.includes(type));
      return c ? c.long_name : null;
    };

    const rawArea =
      findType("sublocality_level_1") ||
      findType("sublocality") ||
      findType("neighborhood") ||
      findType("administrative_area_level_3") ||
      findType("route");
    const area = normalizeAreaName(rawArea);
    const city =
      findType("locality") ||
      findType("postal_town") ||
      findType("administrative_area_level_2");
    const state = findType("administrative_area_level_1");
    const country = findType("country");

    if (area) return area;
    if (city) return city;
    if (state) return state;
    if (country) return country;
    if (place.formatted_address) return place.formatted_address;
    if (place.name) return place.name;
    return "";
  };

  const extractDetailedPlaceInfo = (place) => {
    if (!place) return {};

    const comp = place.address_components || [];
    const findType = (type) => {
      const c = comp.find((x) => x.types && x.types.includes(type));
      return c ? c.long_name : null;
    };

    // Extract detailed location components
    const areaName = normalizeAreaName(
      findType('sublocality') || findType('sublocality_level_1') || findType('neighborhood')
    );
    const city = findType('locality') || findType('administrative_area_level_2');
    const state = findType('administrative_area_level_1');
    const buildingName = findType('premise') || findType('subpremise') || findType('establishment');
    const companyName = place.name || findType('establishment');

    return {
      areaName,
      city,
      state,
      buildingName,
      companyName,
      formattedAddress: place.formatted_address,
      placeId: place.place_id,
      geometry: place.geometry
    };
  };

  const handlePlaceChanged = (autoRef, setLabel, setPlace) => {
    const inst = autoRef.current;
    if (!inst) return;
    const place = inst.getPlace();
    const label = placeToLabel(place) || (place && place.name) || "";

    // Extract detailed place information
    const detailedInfo = extractDetailedPlaceInfo(place);

    if (label) {
      setLabel(label);
      setPlace({
        label,
        placeId: place.place_id,
        geometry: place.geometry,
        raw: place,
        detailedInfo: detailedInfo
      });
    } else {
      // user may have typed free text — keep typed value (no change)
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const resolvedFrom = String(fromLabel || "").trim() || fromPlace?.label || placeToLabel(fromPlace?.raw);
    const resolvedTo = String(toLabel || "").trim() || toPlace?.label || placeToLabel(toPlace?.raw);

    const newErr = {};
    if (!resolvedFrom) newErr.from = "From is required.";
    if (!resolvedTo) newErr.to = "To is required.";

    if (Object.keys(newErr).length) {
      setErrors(newErr);
      return;
    }

    setErrors({});

    const params = {
      from: resolvedFrom,
      to: resolvedTo,
      // Include detailed location information from Google Places API
      fromDetails: fromPlace?.detailedInfo || {},
      toDetails: toPlace?.detailedInfo || {}
    };

    console.log(params);

    if (typeof onSearch === "function") {
      onSearch(params);
    } else {
      const q = new URLSearchParams(params).toString();
      navigate(`/cabs/search?${q}`);
    }
  };

  return (
    <form className="filter-form" onSubmit={handleSubmit} noValidate>
      {/* From */}
      <div className="form-group" style={{ minWidth: '200px', flex: 1 }}>
        {isLoaded ? (
          <Autocomplete
            onLoad={(inst) => {
              fromAutoRef.current = inst;
              try {
                inst.setFields([
                  "formatted_address",
                  "name",
                  "address_components",
                  "geometry",
                  "place_id",
                ]);
              } catch (e) { }
            }}
            onPlaceChanged={() =>
              handlePlaceChanged(fromAutoRef, setFromLabel, setFromPlace)
            }
            options={{
              types: ["geocode", "establishment"],
              fields: ["formatted_address", "name", "address_components", "geometry", "place_id"]
            }}
          >
            <input
              id="fromInput"
              type="text"
              className={`checkin-out ${fromLabel || fromPlace?.label ? "filter-value-active" : ""} ${errors?.from ? "is-invalid" : ""}`}
              placeholder="Andheri East, Mumbai"
              value={fromLabel}
              onChange={(e) => {
                setFromLabel(e.target.value);
                if (errors?.from)
                  setErrors((prev) => ({ ...prev, from: null }));
              }}
              style={{ width: '100%' }}
            />
          </Autocomplete>
        ) : (
          <input
            id="fromInput"
            type="text"
            className={`checkin-out ${fromLabel || fromPlace?.label ? "filter-value-active" : ""} ${errors?.from ? "is-invalid" : ""}`}
            placeholder="From"
            value={fromLabel}
            onChange={(e) => {
              setFromLabel(e.target.value);
              if (errors?.from)
                setErrors((prev) => ({ ...prev, from: null }));
            }}
            style={{ width: '100%' }}
          />
        )}
        {errors?.from && (
          <div
            className="text-danger"
            style={{ fontSize: ".875em", marginTop: 6 }}
          >
            {errors.from}
          </div>
        )}
      </div>

      {/* To */}
      <div className="form-group form-border-left" style={{ minWidth: '200px', flex: 1 }}>
        {isLoaded ? (
          <Autocomplete
            onLoad={(inst) => {
              toAutoRef.current = inst;
              try {
                inst.setFields([
                  "formatted_address",
                  "name",
                  "address_components",
                  "geometry",
                  "place_id",
                ]);
              } catch (e) { }
            }}
            onPlaceChanged={() =>
              handlePlaceChanged(toAutoRef, setToLabel, setToPlace)
            }
            options={{
              types: ["geocode", "establishment"],
              fields: ["formatted_address", "name", "address_components", "geometry", "place_id"]
            }}
          >
            <input
              id="toInput"
              type="text"
              className={`checkin-out ${toLabel || toPlace?.label ? "filter-value-active" : ""} ${errors?.to ? "is-invalid" : ""}`}
              placeholder="Connaught Place, Delhi"
              value={toLabel}
              onChange={(e) => {
                setToLabel(e.target.value);
                if (errors?.to) setErrors((prev) => ({ ...prev, to: null }));
              }}
              style={{ width: '100%' }}
            />
          </Autocomplete>
        ) : (
          <input
            id="toInput"
            type="text"
            className={`checkin-out ${toLabel || toPlace?.label ? "filter-value-active" : ""} ${errors?.to ? "is-invalid" : ""}`}
            placeholder="To"
            value={toLabel}
            onChange={(e) => {
              setToLabel(e.target.value);
              if (errors?.to) setErrors((prev) => ({ ...prev, to: null }));
            }}
            style={{ width: '100%' }}
          />
        )}
        {errors?.to && (
          <div
            className="text-danger"
            style={{ fontSize: ".875em", marginTop: 6 }}
          >
            {errors.to}
          </div>
        )}
      </div>

      <div className="form-group" style={{ minWidth: '120px', alignSelf: "center", flex: 0 }}>
        <button type="submit" className="submit-btn-filter " style={{ width: '100%', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          Search
        </button>
      </div>

      {loadError && (
        <div style={{ color: "red", marginTop: 8, width: '100%' }}>
          Google Maps could not be loaded — autocomplete may not work.
        </div>
      )}
    </form>
  );
}

/* -------------------------
   CabsListing: header + filter + results
   ------------------------- */
function CabsListing({ customSeoData = null, forcedParams = null }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const query = useQuery();
  const navigate = useNavigate();

  const initialFrom = query.get("from") || forcedParams?.from_city || customSeoData?.query_params?.from_city || forcedParams?.city || customSeoData?.query_params?.city || "";
  const initialTo = query.get("to") || forcedParams?.to_city || customSeoData?.query_params?.to_city || "";
  const previewId = query.get("preview_id");
  const isPreviewMode = query.get("preview") === 'true' || Boolean(localStorage.getItem('superAdminToken') && previewId);

  const [filter, setFilter] = useState({
    from: initialFrom,
    to: initialTo,
  });

  const [listings, setListings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalResults, setTotalResults] = useState(0);

  // Filter & Sort state
  const [isVerifiedOnly, setIsVerifiedOnly] = useState(false);
  const [isTopRated, setIsTopRated] = useState(false);
  const [priceSort, setPriceSort] = useState('');

  // Filter & Sort Cabs
  const filteredListings = React.useMemo(() => {
    let list = [...listings];

    // 1. Filter by Verified Vendors only (Aadhaar verified)
    if (isVerifiedOnly) {
      list = list.filter((item) => {
        const vendor = item?.Vendor || item?.vendor;
        return vendor?.is_publicly_verified === true || Number(vendor?.is_publicly_verified) === 1;
      });
    }

    const getPrice = (item) => Number(item?.offer_price || item?.price || item?.package_price || 0);
    const getRating = (item) => {
      const reviews = item?.reviews || [];
      if (reviews.length > 0) {
        return reviews.reduce((sum, r) => sum + parseFloat(r.rating || 0), 0) / reviews.length;
      }
      return Number(item?.avgRating || item?.avg_rating || 0);
    };
    const getReviewCount = (item) => {
      return Number(item?.reviewCount ?? item?.review_count ?? (item?.reviews?.length || 0));
    };

    // 2. Sort by Top Rated or Price
    if (isTopRated) {
      list.sort((a, b) => {
        const rDiff = getRating(b) - getRating(a);
        if (rDiff !== 0) return rDiff;
        const cDiff = getReviewCount(b) - getReviewCount(a);
        if (cDiff !== 0) return cDiff;
        if (priceSort === 'low_to_high') return getPrice(a) - getPrice(b);
        if (priceSort === 'high_to_low') return getPrice(b) - getPrice(a);
        return 0;
      });
    } else if (priceSort === 'low_to_high') {
      list.sort((a, b) => getPrice(a) - getPrice(b));
    } else if (priceSort === 'high_to_low') {
      list.sort((a, b) => getPrice(b) - getPrice(a));
    }

    return list;
  }, [listings, isVerifiedOnly, isTopRated, priceSort]);

  // called when SearchForm submits
  const handleSearch = async (params, pageNum = 1, isLoadMore = false) => {
    console.log("Search params:", params, "Page:", pageNum);

    if (!isLoadMore) {
      setIsLoading(true);
      setFetchError(null);
      setPage(1);
    } else {
      setLoadingMore(true);
    }

    setFilter({
      from: params.from || "",
      to: params.to || "",
    });

    const serializeParams = (searchParams) => {
      const result = {};
      Object.entries(searchParams).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        result[key] = typeof value === 'object' ? JSON.stringify(value) : String(value);
      });
      return result;
    };

    const previewIdParam = query.get("preview_id");
    const previewParam = query.get("preview");
    const extraParams = {};
    if (previewIdParam) extraParams.preview_id = previewIdParam;
    if (previewParam) extraParams.preview = previewParam;

    const serializedParams = serializeParams({ ...params, ...extraParams, page: pageNum, limit: 20 });
    const q = new URLSearchParams(serializedParams).toString();
    const isCustomSeoRoute = Boolean(customSeoData) || window.location.pathname !== '/cabs/search';
    if (!isLoadMore && !previewIdParam && !isCustomSeoRoute) {
      if (params.from && params.to) {
        navigate(`/cabs/search?${q}`);
      } else {
        navigate(`/cabs/search`);
      }
    }

    try {
      const superAdminToken = localStorage.getItem('superAdminToken');
      const headers = superAdminToken ? { Authorization: `Bearer ${superAdminToken}` } : {};
      const res = await axios.get(`${API_BASE_URL}/cabs/search`, { params: serializedParams, headers });
      console.log("API response:", res.data);

      const newData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
      const count = res.data?.total || res.data?.count || newData.length;
      const more = res.data?.hasMore || (newData.length === 20);

      if (isLoadMore) {
        setListings((prev) => [...prev, ...newData]);
      } else {
        setListings(newData);
        setTotalResults(count);
      }
      setHasMore(more);
      setPage(pageNum);
    } catch (err) {
      console.error("Listing fetch error:", err);
      setFetchError("Unable to load listings. Try again.");
    } finally {
      setIsLoading(false);
      setLoadingMore(false);
    }
  };

  const handleLoadMore = () => {
    const params = {
      from: filter.from,
      to: filter.to,
    };
    handleSearch(params, page + 1, true);
  };

  useEffect(() => {
    let fromVal = query.get("from") || forcedParams?.from_city || customSeoData?.query_params?.from_city || forcedParams?.city || customSeoData?.query_params?.city || "";
    let toVal = query.get("to") || forcedParams?.to_city || customSeoData?.query_params?.to_city || "";

    if (!fromVal && !toVal && customSeoData?.custom_url) {
      const parts = customSeoData.custom_url.split('/').filter(Boolean);
      const lastPart = parts[parts.length - 1] || '';
      const routeMatch = lastPart.match(/^([a-zA-Z0-9]+)-to-([a-zA-Z0-9]+)/i);
      if (routeMatch) {
        fromVal = routeMatch[1].replace(/\b\w/g, c => c.toUpperCase());
        toVal = routeMatch[2].replace(/\b\w/g, c => c.toUpperCase());
      } else {
        const clean = lastPart.replace(/-(cab|cabs|taxi|taxis|service|services|booking)/gi, '');
        if (clean && !clean.includes('search')) {
          fromVal = clean.replace(/[\-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
        }
      }
    }

    handleSearch({
      from: fromVal || "",
      to: toVal || "",
    }, 1, false);
  }, [useLocation().search, forcedParams, customSeoData]);

  return (
    <div className="cabs-search-page">
      <SEO
        title={customSeoData?.meta_title || (filter.from && filter.to ? `Cabs from ${filter.from} to ${filter.to} | Mangoloops` : "Affordable Cab Services | Mangoloops")}
        description={customSeoData?.meta_description || "Book reliable and affordable cab services with Mangoloops. Enjoy a comfortable journey with our top-rated cab operators and professional drivers."}
        keywords={customSeoData?.meta_keywords}
        ogTitle={customSeoData?.og_title}
        ogDescription={customSeoData?.og_description}
        ogImage={customSeoData?.og_image}
        canonical={customSeoData?.canonical_url}
        robots={customSeoData?.isPreview ? "noindex, nofollow" : "index, follow"}
      />
      {isPreviewMode && (
        <div className="bg-dark text-white py-2 px-3 d-flex align-items-center justify-content-between shadow-sm" style={{ position: 'relative', zIndex: 1050, background: '#1e293b' }}>
          <div className="d-flex align-items-center gap-2">
            <i className="fas fa-eye text-info"></i>
            <span><strong>Super Admin Preview Mode</strong> &mdash; Viewing preview for Cab Listing {previewId ? `#${previewId}` : ''}. Lead generation and vendor notifications are disabled.</span>
          </div>
          <Link to={`/superadmin/listings-approval/cabs/${previewId || ''}`} className="btn btn-sm btn-outline-light">
            <i className="fas fa-arrow-left me-1"></i> Back to Review
          </Link>
        </div>
      )}
      <LoginPopup />
      <Header />

      {/* ── CUSTOM SEO HTML CONTENT (ABOVE LISTINGS) ── */}
      {customSeoData?.custom_html_content && (customSeoData.content_position === 'above' || customSeoData.content_position === 'Above Listings') && (
        <div className="container mt-4 mb-4">
          <div
            className="custom-seo-html-box p-4 bg-white rounded-3 shadow-sm border"
            dangerouslySetInnerHTML={{ __html: customSeoData.custom_html_content }}
          />
        </div>
      )}

      <div className="banner-content bg-img-hero text-center mb-5 cabs-search-hero" style={{ backgroundImage: "url('/assets/img/cabs/banner.png')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container-fluid container-package">
          <div className="row justify-content-center py-xl-4">
            <div className="card border-0 border-radius-12 tab-shadow cabs-search-filter-card">
              <div className="card-body padding-14 cabs-search-filter-body">
                <SearchForm
                  initial={{
                    from: filter.from,
                    to: filter.to,
                  }}
                  onSearch={handleSearch}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Results section */}
      <div className="container cabs-search-results">
        <div className="row mb-3">
          <div className="col-12 d-flex justify-content-between align-items-center flex-wrap gap-2">
            <h3 className="fw-bold mb-0 text-start heading-div">
              {isLoading ? "Searching..." : "Available Cabs"}
            </h3>
            <div className="d-flex align-items-center flex-wrap gap-3">
              <ListingFilterBar
                priceSort={priceSort}
                onPriceSortChange={setPriceSort}
                isTopRated={isTopRated}
                onTopRatedToggle={() => setIsTopRated((prev) => !prev)}
                isVerifiedOnly={isVerifiedOnly}
                onVerifiedToggle={() => setIsVerifiedOnly((prev) => !prev)}
              />
              {!isLoading && (
                <div className="text-muted" style={{ fontSize: 14, whiteSpace: 'nowrap' }}>
                  Showing {filteredListings.length} results {totalResults > 0 ? `of ${totalResults}` : ""}
                </div>
              )}
            </div>
          </div>
        </div>

        {isLoading && page === 1 ? (
          <div>Loading results...</div>
        ) : fetchError ? (
          <div className="text-danger">{fetchError}</div>
        ) : filteredListings.length === 0 ? (
          <div className="text-muted text-center py-4">No cabs found matching your selected filters.</div>
        ) : (
          <>
            <div style={{ display: "grid", gap: 18 }}>
              {filteredListings.map((l, i) => (
                <CabCard key={l?.id || i} cab={l} />
              ))}
            </div>

            {/* LOAD MORE BUTTON */}
            {hasMore && (
              <div className="text-center mt-5 mb-5">
                <button
                  className="btn btn-primary px-5 py-2 fw-bold rounded-pill shadow-sm"
                  onClick={handleLoadMore}
                  disabled={loadingMore}
                  style={{ backgroundColor: '#32AEE4', borderColor: '#32AEE4' }}
                >
                  {loadingMore ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Loading More...
                    </>
                  ) : (
                    "Load More"
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* ── CUSTOM SEO HTML CONTENT (BELOW LISTINGS) ── */}
      {customSeoData?.custom_html_content && (customSeoData.content_position === 'below' || customSeoData.content_position === 'Below Listings') && (
        <div className="container mt-4 mb-5">
          <div
            className="custom-seo-html-box p-4 bg-white rounded-3 shadow-sm border"
            dangerouslySetInnerHTML={{ __html: customSeoData.custom_html_content }}
          />
        </div>
      )}

      <Footer />
    </div>
  );
}

export default CabsListing;
